import { render } from "./AppNotifications.vue?vue&type=template&id=3e63d138&ts=true"
import script from "./AppNotifications.vue?vue&type=script&lang=ts"
export * from "./AppNotifications.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Users\\qzgde\\projects\\NODE\\i-activity-v3.1-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__